import * as galleryVideos from "./galleryVideos";

export function init($name = '') {
    const projects = $($name);

    if (!projects.length) {
        return;
    }

    projects.each(function () {
        const project = $(this);
        const categories = project.find($name + '-category');

        window.galleryCurrentCategory = project.data('category');
        window.galleryCurrentTag = project.data('tag');
        window.galleryCurrentPage = project.data('page');
        window.galleryMaxPosts = project.data('max-posts');
        window.galleryProjectsPage = project.data('projects-url');
        window.galleryCanLoadMore = project.find($name + '-section-posts').children().children().length >= window.galleryMaxPosts;

        categories.click(function () {
            if ($(this).hasClass('is-active')) {
                return;
            }

            categories.removeClass('is-active');
            $(this).addClass('is-active');

            window.galleryCurrentCategory = $(this).attr('data-cat');
            window.galleryCurrentTag = null;
            window.galleryCurrentPage = 1;

            reloadContent(true, project, $name);
        });

        tagsClick(project, $name);

        $(window).scroll(function() {
            if (!window.galleryCanLoadMore) {
                return;
            }

            if ($(document).scrollTop() + $(window).height() + 150 < project.find($name + '-section-posts').offset().top + project.find($name + '-section-posts').height()) {
                return;
            }

            window.galleryCanLoadMore = false;
            window.galleryCurrentPage += 1;
            loadMoreContent(project, $name);
        });
    });
}

function reloadContent(contentChange, project, $name) {
    project.find($name + '-section-posts-video').addClass('initialized-before');
    project.find($name + '-loader').show();
    project.find($name + '-section-posts').hide();

    let url = window.galleryProjectsPage;

    if (window.galleryCurrentCategory) {
        url += '/' + window.galleryCurrentCategory;
    }

    if (window.galleryCurrentTag) {
        url += '/' + window.galleryCurrentTag;
    }

    if (window.galleryCurrentPage && window.galleryCurrentPage > 1) {
        url += '?pOffset=' + window.galleryCurrentPage;
    }

    url += '/';

    $.ajax(url, {
        data : {
            pOffset : window.galleryCurrentPage
        },
        error : function () {
            window.galleryCanLoadMore = false;
            project.find($name + '-loader').hide();
        }
    }).done(function (document) {
        const body = $(document);

        window.galleryCanLoadMore = true;

        if (contentChange) {
            project.find($name + '-section-description').html(body.find($name + '-section-description').html());
            project.find($name + '-section-tags').html(body.find($name + '-section-tags').html());
            tagsClick(project, $name);
        }

        project.find($name + '-section-posts').html(body.find($name + '-section-posts').html());

        if ($(body.find($name + '-section-posts').html()).children().children().length < window.galleryMaxPosts) {
            window.galleryCanLoadMore = false;
        }

        galleryVideos.init('.js-trigger-gallery-video:not(.initialized-before)');

        project.find($name + '-section-posts').show();
        project.find($name + '-loader').hide();

        history.pushState({}, 'Push state for projects', url);
    });
}

function loadMoreContent(project, $name) {
    project.find($name + '-section-posts-video').addClass('initialized-before');
    project.find($name + '-loader').show();

    let url = window.galleryProjectsPage;

    if (window.galleryCurrentCategory) {
        url += '/' + window.galleryCurrentCategory;
    }

    if (window.galleryCurrentTag) {
        url += '/' + window.galleryCurrentTag;
    }

    url += '/';

    $.ajax(url, {
        data : {
            pOffset : window.galleryCurrentPage
        },
        error : function () {
            window.galleryCanLoadMore = false;
            project.find($name + '-loader').hide();
        }
    }).done(function (document) {
        const body = $(document);

        window.galleryCanLoadMore = true;

        $(body.find($name + '-section-posts').html()).children().appendTo(project.find($name + '-section-posts').children());

        if ($(body.find($name + '-section-posts').html()).children().children().length < window.galleryMaxPosts) {
            window.galleryCanLoadMore = false;
        }

        galleryVideos.init('.js-trigger-gallery-video:not(.initialized-before)');

        project.find($name + '-loader').hide();

        history.pushState({}, 'Push state for projects', url);
    });
}

function tagsClick(project, $name) {
    $(project).find($name + '-tag').click(function () {
        if ($(this).hasClass('is-active')) {
            return;
        }

        $(project).find($name + '-tag').removeClass('is-active');
        $(this).addClass('is-active');

        window.galleryCurrentTag = $(this).attr('data-slug');
        window.galleryCurrentPage = 1;

        reloadContent(false, project, $name);
    });
}

